import { toString } from "../../../fable_modules/fable-library-js.4.19.0/Date.js";
import * as react from "react";
import { empty, toArray, map } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { empty as empty_1, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.4.19.0/Seq.js";
import { pagination, errorMsg, spinner } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";
import { equals } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { Model__CanConfirm, Model__IsSending, Msg, Page } from "./Types.fs.js";
import { ConfirmSettings, Accept, UploadBox } from "../../../../Bfs.Web.Portale/UploadBox.fs.js";

export function dtaListItemView(dta) {
    let children_4, children, children_2;
    const children_10 = [(children_4 = [(children = [toString(dta.Hochgeladen, "dd.MM.yyyy ")], react.createElement("span", {}, ...children)), (children_2 = [`${toString(dta.Hochgeladen, "HH:mm")} Uhr`], react.createElement("span", {
        className: "pre",
    }, ...children_2))], react.createElement("td", {}, ...children_4)), react.createElement("td", {}, dta.Dateiname), react.createElement("td", {}, dta.Statusmeldung)];
    return react.createElement("tr", {}, ...children_10);
}

export function dtaTable(dtaDateien) {
    let children_8, children_6, children_10;
    const children_12 = [(children_8 = [(children_6 = [react.createElement("th", {}, "Hochgeladen am"), react.createElement("th", {}, "Dateiname"), react.createElement("th", {}, "Status")], react.createElement("tr", {}, ...children_6))], react.createElement("thead", {}, ...children_8)), (children_10 = map(dtaListItemView, dtaDateien), react.createElement("tbody", {}, ...children_10))];
    return react.createElement("table", {
        className: "table table-striped responsive-table is-hidden-mobile",
    }, ...children_12);
}

export function dtaTableMobile(dtaDateien) {
    const children_14 = [toArray(map((f) => {
        let children_8, children_6, children_2, children_4;
        const children_12 = [(children_8 = [react.createElement("div", {
            className: "dta-file",
        }, f.Dateiname), (children_6 = [(children_2 = [toString(f.Hochgeladen, "dd.MM.yyyy ")], react.createElement("span", {}, ...children_2)), (children_4 = [`${toString(f.Hochgeladen, "HH:mm")} Uhr`], react.createElement("span", {
            className: "pre",
        }, ...children_4))], react.createElement("div", {
            className: "dta-date",
        }, ...children_6))], react.createElement("div", {}, ...children_8)), react.createElement("div", {
            className: "dta-status",
        }, f.Statusmeldung)];
        return react.createElement("div", {
            className: "data-item",
        }, ...children_12);
    }, dtaDateien))];
    return react.createElement("div", {
        className: "data-list is-hidden-tablet",
    }, ...children_14);
}

export function dtaListBox(model, navigateTo) {
    const children_14 = toList(delay(() => {
        let children_12, children_4, children_2, children_10;
        return append(singleton((children_12 = [(children_4 = [(children_2 = [react.createElement("b", {}, "Aktuelle DTA-Dateien")], react.createElement("h3", {}, ...children_2))], react.createElement("div", {
            className: "card-title",
        }, ...children_4)), (children_10 = toList(delay(() => {
            const matchValue = model.DtaList;
            return (matchValue.tag === 1) ? singleton(spinner) : ((matchValue.tag === 2) ? singleton(errorMsg("Fehler beim Laden der DTA-Dateien!")) : ((matchValue.tag === 3) ? (equals(matchValue.fields[0].Items, empty()) ? singleton(react.createElement("div", {}, "Keine DTA-Dateien vorhanden")) : append(singleton(dtaTable(matchValue.fields[0].Items)), delay(() => singleton(dtaTableMobile(matchValue.fields[0].Items))))) : singleton(react.createElement("div", {}))));
        })), react.createElement("div", {
            className: "card-body",
        }, ...children_10))], react.createElement("div", {
            className: "flat-card profile-info-card is-auto",
        }, ...children_12))), delay(() => {
            const matchValue_1 = model.DtaList;
            if (matchValue_1.tag === 3) {
                return singleton(pagination(matchValue_1.fields[0], (page) => {
                    navigateTo(new Page(page));
                }));
            }
            else {
                return empty_1();
            }
        }));
    }));
    return react.createElement("div", {
        className: "column is-9-desktop is-relative",
    }, ...children_14);
}

export function dtaUploadBox(model, dispatch) {
    const children = [UploadBox([new Accept(0, []), (fileList) => {
        dispatch(new Msg(2, [fileList]));
    }, (file) => {
        dispatch(new Msg(4, [file]));
    }, model.UploadList, model.UploadCount, new ConfirmSettings(Model__IsSending(model), Model__CanConfirm(model), () => {
        dispatch(new Msg(6, []));
    }), (msg) => {
        dispatch(new Msg(8, [msg]));
    }])];
    return react.createElement("div", {
        className: "column is-3-desktop is-relative is-hidden-touch",
    }, ...children);
}

export function view(model, dispatch, navigateTo) {
    const children = [dtaUploadBox(model, dispatch), dtaListBox(model, (arg) => {
        navigateTo(arg);
    })];
    return react.createElement("div", {
        className: "columns is-desktop is-account-grid is-multiline datenuebergabe",
    }, ...children);
}

//# sourceMappingURL=View.fs.js.map
